import { useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import { GetEntryAPI } from "../services/index.js";
import { TransferToGatewayAPI } from "../services/index.js";
import { useDispatch, useSelector } from 'react-redux';
import { LanguageLoader } from '../assets/languages/index.js';
import { useLocation } from "react-router-dom";
import { Toastify } from '../components/utils';
import { DateFormat } from '../components/utils';
import { GatewaySkeleton } from "../components/layouts/Skeleton";
import { useNavigate } from "react-router-dom";

const Gateway = () =>
{
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);	
	const language = LanguageLoader(preferences.language);
	const [loading, SetLoading] = useState(true);
	const [dataEntry, SetDataEntry] = useState({});
	const {module, id} = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const params = new URLSearchParams(location.search);
	const callBackUrl = params.get("callback");

	useEffect(() => {
		window.scrollTo(0, 0);
		SetLoading(true);
		GetEntry();
	// eslint-disable-next-line
	}, [module, id]);

	const GetEntry = async () => {
		const data = {
			id: id,
			module: module
		};
		const APIResponse = await GetEntryAPI(data);
		if (APIResponse)
		{
			SetDataEntry(APIResponse[0]);
			SetLoading(false);
		}
	};

	const TransferToGateway = async() =>
	{
		const data = {
			id: id,
			module: module,
			gateway: 'samankish', // this is hard coded and can be diffrent for each gateway later.
			callBackUrl: document.URL
		};
		const APIResponse = await TransferToGatewayAPI(data);
		if (APIResponse)
		{
			RedirectToGateway(APIResponse);
		}
	}

	const RedirectToGateway =  (gatewayData) => {
		if(gatewayData.token == false)
		{
			Toastify(language["GATEWAY"]["LBL_FAILED_PAYMENT_STATUS"]);
			return;
		}
		const token = gatewayData.token;
		const form = document.createElement("form");
		form.method = "POST";
		form.action = "https://sep.shaparak.ir/OnlinePG/OnlinePG";
		form.innerHTML = `
			<input type="hidden" name="Token" value="${token}" />
			<input type="hidden" name="GetMethod" value="" />
		`;
		document.body.appendChild(form);
		form.submit();
		setTimeout(() => form.remove(), 500);
	};

	const ReturnToDetailView = () => {
		navigate(`/detail/${module}/${id}`);
	}

	return(
		<>
		{callBackUrl === 'OK' && dataEntry.stage === 'Closed Accepted' && (
			<div class="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md" role="alert">
				<div class="flex">
					<div class="py-1"><svg class="fill-current h-6 w-6 text-teal-500 mr-4 ml-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
					<div>
						<p class="font-bold">{language["GATEWAY"]["LBL_SUCCESS"]}</p>
						<p class="text-sm">{language["GATEWAY"]["LBL_SUCCESS_PAYMENT_STATUS"]}</p>
					</div>
				</div>
			</div>
		)}
		{loading ? <GatewaySkeleton/> :
			<div className="wrapper flex flex-wrap gatewaySummery">
				<div className="title">
					<div className="w-full flex justify-between my-2">
						<h4 className="w-1/3">{language["GATEWAY"]["LBL_PAY_INFORMATION"]}</h4>
						<i className="fa-solid fa-credit-card m-auto bg-success w-20 h-20 text-center pt-6 rounded-full text-white text-[27px] !-mt-10"></i>
						<div className="w-1/3 text-end">
						{dataEntry.stage === 'Closed Accepted' ? (
							<span className="payment-status bg-success shadow-success">{language["GATEWAY"]["LBL_ALREADY_PAID"]}</span>
							)	:
							<span className="payment-status bg-warning shadow-warning">{language["GATEWAY"]["LBL_NOT_PAID"]}</span>
						}
						</div>
					</div>
				</div>
				<div className="Field_Container">
					<div className="flex">
						<label>{language["FIELDS"]["TITLE"]} </label>
					</div>
					<div className="value">{dataEntry.name}</div>
				</div>
				<div className="Field_Container">
					<div className="flex">
						<label>{language["FILTER"]["DATE_ENTERED"]} </label>
					</div>
					<div className="value flex items-center"><span>{DateFormat(dataEntry.date_entered)}</span></div>
				</div>
				<div className="Field_Container">
					<div className="flex">
						<label>{language["GATEWAY"]["LBL_ACCOUNT"]} </label>
					</div>
					<div className="value">{dataEntry.billing_account}</div>
				</div>
				<div className="Field_Container">
					<div className="flex">
						<label>{language["GATEWAY"]["LBL_GATEWAY_DESCRIPTION"]} </label>
					</div>
					<div className="value">{language["GATEWAY"]["LBL_SAMAN_GATEWAY"]}</div>
				</div>
				<div className="w-full flex justify-center mb-4">
					<div className="w-1/2 bg-containerBG rounded-xl p-3">
						<label className="text-center">{language["GATEWAY"]["LBL_AMOUNT_PAYABLE"]}</label>
						<div className="text-center text-xl font-bold">
							{dataEntry?.total_amount? Number(parseFloat(dataEntry.total_amount).toFixed(1)).toLocaleString(): "0"} 
							<span className="ms-2">{language['GATEWAY']['LBL_CURRENCY_RIAL']}</span>
						</div>
					</div>
				</div>
				{dataEntry.stage !== 'Closed Accepted' ? (
					settings.payOn.includes(module) ? (
						<button onClick={TransferToGateway} className='btn mb-2 w-full'>
							{language["GATEWAY"]["LBL_TRANSFER_TO_GATEWAY"]}
							<i className="fa-solid fa-arrow-left ms-2"></i>
						</button>
					) : null
				) : 
				<button onClick={ReturnToDetailView} className='btn mb-2 w-full'>
					{language["GATEWAY"]["LBL_RETURN_TO_BACK"]}
					<i className="fa-solid fa-arrow-left ms-2"></i>
				</button>
				}
			</div>
		}
		{loading ? null :
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="SvgGateway">
				<path fill="#16b36d" fill-opacity="1" d="M0,160L48,154.7C96,149,192,139,288,117.3C384,96,480,64,576,53.3C672,43,768,53,864,85.3C960,117,1056,171,1152,197.3C1248,224,1344,224,1392,224L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
			</svg>
		}
		</>
	)
}

export default Gateway;